import useSnackbarStore from '@/store/snackbar';

/**
 * api:
 * This function is used to handle fetching data from the server
 * It takes the request and the options for the fetch
 * It returns the data and the error
 *
 * Using $fetch to make network requests based on user interaction.
 *
 * @param {NitroFetchRequest} request: The request to fetch the data
 * @param {NitroFetchOptions} opts: The options for the fetch
 * @returns {pending, data, error, execute}
 */
export default defineNuxtPlugin(() => {
  const snackbar = useSnackbarStore();
  const requestHeaders: HeadersInit = new Headers();
  requestHeaders.set('Content-Type', 'application/json; charset=utf-8');

  const $api = $fetch.create({
    baseURL: useRuntimeConfig().public.apiURL,
    headers: {
      Accept: 'application/json',
    },
    onRequest({ request, options, error }) {
      const accessToken = useCookie(useRuntimeConfig().public.auth?.provider?.token?.cookieName || 'auth:token');
      if (accessToken.value) {
        options.headers = new Headers(options.headers || {});
        options.headers.set('Authorization', `Bearer ${accessToken.value}`);
      }
    },
    async onResponseError({ response }) {
      if (
        !['ACCOUNT_BLOCKED', 'USERNAME_NOT_FOUND', 'ACCOUNT_DISABLED', 'INVALID_ONE_TIME_PASSWORD'].includes(
          response._data.error_code
        )
      ) {
        snackbar.showSnackbar({
          text: response._data.message,
          state: false,
        });
      }
    },
  });

  return {
    provide: {
      api: $api,
    },
  };
});
